module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-hidden"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": ""
    }
  }, [
    [_c('v-card', [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1 primary--text",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "fw-700 font-16"
    }, [_vm._v(_vm._s(_vm.$t('right.myWallet')))])]), _vm._v(" "), (!_vm.isLogin) ? _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 fw-400 pointer"
    }, [_c('span', {
      on: {
        "click": _vm.gotoRegister
      }
    }, [_vm._v(_vm._s(_vm.$t('right.signUp')))]), _vm._v(" "), _c('span', {
      on: {
        "click": _vm.login
      }
    }, [_vm._v(" / " + _vm._s(_vm.$t('right.login')))])])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 pointer"
    }, [_c('span', {
      staticClass: "font-28 primary--text fw-700"
    }, [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower : 0).toFixed(2)))))]), _vm._v(" "), _c('span', {
      staticClass: "font-14 fw-500"
    }, [_vm._v("IOB Power / " + _vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower : 0).toFixed(2)))) + " USD")])])]) : _vm._e()], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 primary--text"
    }, [_vm._v(_vm._s(_vm.$t('right.iobannouncements')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, _vm._l((_vm.bulletinBoardData), function(msg) {
      return _c('span', {
        staticClass: "font-14"
      }, [_vm._v("\n                    " + _vm._s(_vm.$t(msg.before))), _c('span', {
        staticClass: "primary--text"
      }, [_vm._v(_vm._s(_vm._f("NumFormat")(msg.data)))]), _vm._v(_vm._s(_vm.$t(msg.after)) + "\n                  ")])
    }), 0)], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "fw-700 font-16 primary--text"
    }, [_vm._v(_vm._s(_vm.$t('right.links')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 fw-500 pointer",
      on: {
        "click": _vm.goMyFeed
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.myFeed')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 fw-500 pointer",
      on: {
        "click": _vm.goUserData
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.myBlog')) + "\n                  ")])])], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16 primary--text"
    }, [_vm._v(_vm._s(_vm.$t('right.sort')))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.gotoHot
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.hot')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.gotoNew
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.new')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.gotoNewsTopic
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.industryNews')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.findByTelegramList
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.IOBOfficialTelegram')) + "\n                  ")])])], 1)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "mt-3 ml-3 mr-3"
    }, [_c('label', {
      staticClass: "mt-3 primary--text font-16"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("right.allTags")) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 mb-3"
    }, _vm._l((_vm.tagList), function(tag, index) {
      return _c('Tag', {
        key: tag.tagId,
        staticClass: "font-14",
        attrs: {
          "type": "border"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.findtagposting(tag.tagName)
          }
        }
      }, [_vm._v(_vm._s(tag.tagName))])])
    }), 1)])])], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1 primary--text",
      attrs: {
        "xs12": "",
        "md12": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-16"
    }, [_vm._v(_vm._s(_vm.$t("right.hotTopics")))])]), _vm._v(" "), _vm._l((_vm.marketsList), function(market) {
      return _c('v-flex', {
        key: market.marketId,
        staticClass: "pa-1",
        attrs: {
          "xs12": "",
          "md8": "",
          "lg12": ""
        }
      }, [_c('span', {
        staticClass: "font-14 pointer",
        on: {
          "click": function($event) {
            return _vm.findByMarkets(market)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(market.name) + "\n                  ")])])
    }), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-1",
      attrs: {
        "xs12": "",
        "md8": "",
        "lg12": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.findByTelegramList
      }
    }, [_vm._v("\n                    IOB Official Telegram\n                  ")])])], 2)], 1)], 1)], _vm._v(" "), [_c('v-card', {
      staticClass: "mt-3"
    }, [_c('v-container', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-1 primary--text",
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": ""
      }
    }, [_c('span', {
      staticClass: "font-16"
    }, [_vm._v("IOB LLC")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('div', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goAbout
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.about')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('div', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goIobots
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.iobots')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goPoet
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.poet')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goIr
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.investorRelations')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goFaq
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.faq')) + "\n                  ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": "",
        "sm6": "",
        "pa-1": ""
      }
    }, [_c('span', {
      staticClass: "font-14 pointer",
      on: {
        "click": _vm.goContact
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('right.contact')) + "\n                  ")])])], 1)], 1)], 1)]
  ], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd04760c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Right.vue
// module id = 468
// module chunks = 0